import styled from 'styled-components';
import { CssSpace } from '@xbcb/ui-types';

export const StyledContainer = styled.div`
  margin-top: ${CssSpace.SPACE_4};
`;
